import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0F766E',
        secondary: '#475569',
        accent: '#D97706',
        error: '#DC2626',
        info: '#2563EB',
        success: '#15803D',
        warning: '#D97706',
      }
    }
  }
});
